









































































































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import TheAddonsFields from '@/components/products/TheAddonsFields.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
// Importing variables
import {TagsProduct} from '@/ts/variables';

export default {
    name: 'TheFormProducts1',
    components: {
        BaseButton,
        BaseInputField,
        TheAddonsFields,
        BaseLoadingAnimation,
    },
    props: {
        product: Object,
        errors: Array,
    },
    data() {
        return {
            tags: Array(),
            temp: Object(),
        };
    },
    methods: {
        addIngredient() {
            this.product.ingredients.push({ name: this.temp.name, is_optional: this.temp.is_optional });
        },
        deleteIngredient(index) {
            this.product.ingredients.splice(index, 1);
        },
    },
    computed: {
        categories() {
            return this.$store.getters.response.map((item) => {
                return {
                    text: item.attributes.name,
                    value: item.id,
                };
            });
        },
    },
    created() {
        this.tags = TagsProduct;
        this.temp = {
            name: '',
            is_optional: '',
        };
    },
};
